<template>
  <v-container>
    <v-row class="mb-6">
      <v-col class="text-left">
        <h1>Top Rated</h1>
      </v-col>
      <v-col class="text-right">
        <router-link
          :to="{
            name: 'SeeAll',
            params: { pageData: toprated, pageHeading: 'Top Rated' },
          }"
          @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-SeeAll-TopRated-page',
  eventLabel: 'home-grid'
})"
        >
          <v-btn outlined aria-label="See all Top Rated button"
            >See All
            <v-icon class="pl-4" title="See all top rated"
              >mdi-dots-horizontal</v-icon
            ></v-btn
          >
        </router-link>
      </v-col>
    </v-row>
    <SlideGroup :isLoading="isLoading" :slideData="toprated" />

    <v-row class="mt-12 mb-6">
      <v-col class="text-left">
        <h1>Featured</h1>
      </v-col>
      <v-col class="text-right">
        <router-link
          :to="{
            name: 'SeeAll',
            params: { pageData: featured, pageHeading: 'Featured' },
          }"
          @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-SeeAll-Featured-page',
  eventLabel: 'home-grid'
})"
        >
          <v-btn outlined aria-label="See all Featured button"
            >See All
            <v-icon class="pl-4" title="see all featured">mdi-dots-horizontal</v-icon>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

    <SlideGroup :isLoading="isLoading" :slideData="featured" />

    <v-row class="mt-12 mb-6">
      <v-col class="text-left">
        <h1>Latest</h1>
      </v-col>
      <v-col class="text-right">
        <router-link
          :to="{
            name: 'SeeAll',
            params: { pageData: latest, pageHeading: 'Latest' },
          }"
          @click="this.$ga.event({
  eventCategory: 'home',
  eventAction: 'route-to-SeeAll-Latest-page',
  eventLabel: 'home-grid'
})"
        >
          <v-btn outlined aria-label="See all Latest button"
            >See All
            <v-icon class="pl-4" title="see all latest"
              >mdi-dots-horizontal</v-icon
            ></v-btn
          >
        </router-link>
      </v-col>
    </v-row>
    <SlideGroup :isLoading="isLoading" :slideData="latest" />
  </v-container>
</template>

<script>
import axios from 'axios';
import SlideGroup from './SlideGroup';

export default {
  name: 'HomeGrid',
  components: {
    SlideGroup,
  },
  data() {
    return {
      show: false,
      active: null,
      toggle: null,
      imageUrl: '',
      toprated: [],
      featured: [],
      latest: [],
      isLoading: true,
    };
  },
  mounted() {
    // un comment this when ready to use api
    // this.imageUrl = this.unsplash("senior");
    this.getTopRated();

    this.getFeatured();

    this.getLatest();
  },
  methods: {
    getTopRated() {
      axios
        .get(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?maxRecords=12&view=Grid%20view&filterByFormula=NOT%28%7BRATING%7D%20%3D%20%27%27%29&sort%5B0%5D%5Bfield%5D=RATING&sort%5B0%5D%5Bdirection%5D=desc',
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            // console.log(r.data.records);
            this.toprated = r.data.records;
            this.isLoading = false;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getLatest() {
      axios
        .get(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?maxRecords=12&view=Grid%20view&filterByFormula=NOT%28%7BTIMESTAMP%7D%20%3D%20%27%27%29&sort%5B0%5D%5Bfield%5D=TIMESTAMP',
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            // console.log(r.data.records);
            this.latest = r.data.records;
            this.isLoading = false;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getFeatured() {
      axios
        .get(
          'https://api.airtable.com/v0/appTSgks8Hbv4l0Lb/item-data?maxRecords=12&view=Grid%20view&filterByFormula=NOT%28%7BFEATURED%7D%20%3D%20%27%27%29',
          {
            headers: {
              Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_TOKEN}`,
            },
          }
        )
        .then(
          (r) => {
            // console.log(r.data.records);
            this.featured = r.data.records;
            this.isLoading = false;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    unsplash(query) {
      const options = {
        method: 'GET',
        headers: {
          'Accept-Version': 'v1',
          Authorization:
            'Client-ID y0rCTI7B49WJSg_I1dPXeLqHuAGRisqtbM_BTn-BBq4',
        },
      };
      fetch(
        `https://api.unsplash.com/photos/random?query=${query}?featured`,
        options
      )
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          this.imageUrl = data.urls.regular;
        });
      // console.log(this.imageUrl);
    },
  },
};
</script>
